import ActionTypes from '../actions/actionTypes';

const initialState = {
  everydayRewardsEnrolmentStatusLoading: false,
  everydayRewardsEnrolmentStatusLoaded: false,
  everydayRewardsEnrolmentStatusError: false,
  everydayRewardsEnrolmentStatus: {},
  everydayRewardsEnrolmentStatusLinking: false, 

  everydayRewardsLoginUriLoading: false,
  everydayRewardsLoginUriLoaded: false,
  everydayRewardsLoginUriError: false,
  everydayRewardsLoginUri: '',

  everydayRewardsConnectLoading: false,
  everydayRewardsConnectLoaded: false,
  everydayRewardsConnectError: false,

  everydayRewardsDisconnectLoading: false,
  everydayRewardsDisconnectLoaded: false,
  everydayRewardsDisconnectError: false,
};

export function everydayRewardsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.REQUEST:
      return {
        ...state,
        everydayRewardsEnrolmentStatusLoading: true,
        everydayRewardsEnrolmentStatusLoaded: false,
        everydayRewardsEnrolmentStatusError: false,
        everydayRewardsEnrolmentStatus: {},
        everydayRewardsEnrolmentStatusLinking: payload.isLinking,
      };
    case ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.SUCCESS:
      return {
        ...state,
        everydayRewardsEnrolmentStatusLoading: false,
        everydayRewardsEnrolmentStatusLoaded: true,
        everydayRewardsEnrolmentStatus: payload.everydayRewardsEnrolmentStatus,
      };
    case ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.FAILURE:
      return {
        ...state,
        everydayRewardsEnrolmentStatusLoading: false,
        everydayRewardsEnrolmentStatusError: true,
      };
    case ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.REQUEST:
      return {
        ...state,
        everydayRewardsLoginUriLoading: true,
        everydayRewardsLoginUriLoaded: false,
        everydayRewardsLoginUriError: false,
        everydayRewardsLoginUri: ''
      };
    case ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.SUCCESS:
      return {
        ...state,
        everydayRewardsLoginUriLoading: false,
        everydayRewardsLoginUriLoaded: true,
        everydayRewardsLoginUri: payload.everydayRewardsLoginUri
      };
    case ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.FAILURE:
      return {
        ...state,
        everydayRewardsLoginUriLoading: false,
        everydayRewardsLoginUriError: true
      };
    case ActionTypes.EVERYDAY_REWARDS.CONNECT.REQUEST:
      return {
        ...state,
        everydayRewardsConnectLoading: true,
        everydayRewardsConnectLoaded: false,
        everydayRewardsConnectError: false
      };
    case ActionTypes.EVERYDAY_REWARDS.CONNECT.SUCCESS:
      return {
        ...state,
        everydayRewardsConnectLoading: false,
        everydayRewardsConnectLoaded: true
      };
    case ActionTypes.EVERYDAY_REWARDS.CONNECT.FAILURE:
      return {
        ...state,
        everydayRewardsConnectLoading: false,
        everydayRewardsConnectError: true
      };
    case ActionTypes.EVERYDAY_REWARDS.DISCONNECT.REQUEST:
      return {
        ...state,
        everydayRewardsDisconnectLoading: true,
        everydayRewardsDisconnectLoaded: false,
        everydayRewardsDisconnectError: false
      };
    case ActionTypes.EVERYDAY_REWARDS.DISCONNECT.SUCCESS:
      return {
        ...state,
        everydayRewardsDisconnectLoading: false,
        everydayRewardsDisconnectLoaded: true
      };
    case ActionTypes.EVERYDAY_REWARDS.DISCONNECT.FAILURE:
      return {
        ...state,
        everydayRewardsDisconnectLoading: false,
        everydayRewardsDisconnectError: true
      };
    default:
      return state;
  }
}
